import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

/**
 * Masked line-by-line reveal. Pass an array of strings (lines).
 */
export const RevealText = ({ lines = [], className = "", delay = 0, stagger = 0.12, as = "span" }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            style={{ display: "block" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

/**
 * Scroll-triggered fade-up wrapper.
 */
export const Reveal = ({ children, className = "", delay = 0, y = 40, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export { EASE };
